export class EndPointRef {
  label: string;
  description: string;
  endPointId: string;
}
